import { all } from "redux-saga/effects"
import read from "./read"

export default function* statusSaga() {
  while (true) {
    yield all({
      read: read(),
    })
  }
}
